export interface NotesAttachmentsConfig {
  visible: boolean;
  showNotes: boolean;
  showAttachments: boolean;
  notesMandatory: boolean;
  attachmentsMandatory: boolean;
}

export const HIDDEN_NOTES_ATTACHMENTS_CONFIG: NotesAttachmentsConfig = Object.freeze({
  visible: false,
  showNotes: false,
  showAttachments: false,
  notesMandatory: false,
  attachmentsMandatory: false,
});

const lowerKeys = (obj: unknown): Record<string, any> => {
  const out: Record<string, any> = {};
  if (obj && typeof obj === 'object') {
    for (const key of Object.keys(obj)) out[key.toLowerCase()] = (obj as Record<string, unknown>)[key];
  }
  return out;
};

const isMandatory = (key: any): boolean =>
  !!key && (key.mandatory === true || String(key.mandatory).toLowerCase() === 'true');

/** Parses BU_ACTIVITY_GA_NOTES_ATTACHMENTS (a JSON array keyed by activityType). */
export function parseNotesAttachmentsConfig(raw: unknown, activityTypes: string[]): NotesAttachmentsConfig {
  if (!raw) return HIDDEN_NOTES_ATTACHMENTS_CONFIG;
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw as string);
  } catch {
    return HIDDEN_NOTES_ATTACHMENTS_CONFIG;
  }
  if (!Array.isArray(parsed) || parsed.length === 0) return HIDDEN_NOTES_ATTACHMENTS_CONFIG;

  const entry = parsed.map(lowerKeys).find((e) => activityTypes.includes(String(e['activitytype']).toLowerCase()));
  if (!entry) return HIDDEN_NOTES_ATTACHMENTS_CONFIG;

  const showNotes = entry['notes'] != null;
  const showAttachments = entry['attachments'] != null;
  if (!showNotes && !showAttachments) return HIDDEN_NOTES_ATTACHMENTS_CONFIG;

  return {
    visible: true,
    showNotes,
    showAttachments,
    notesMandatory: showNotes && isMandatory(entry['notes']),
    attachmentsMandatory: showAttachments && isMandatory(entry['attachments']),
  };
}
